export const get = ({ params }) => {
    const url = constructURL({ params })
    return fetch(url)
}

const constructURL = ({ params }) => {
    const endpoint = window.location.origin + '/api/availability'
    const url = new URL(endpoint)
    Object.entries(params).forEach(e => url.searchParams.append(...e))
    return url
}
